export default __webpack_public_path__ + "media/images/upsell_bg_sm-132613cf5d23bd3ff21e08a3f8246462.jpg";